import { useCallback, useEffect, useState } from 'react';
import defaultLoader from 'components/gruenland/atoms/image/loaders/default';
import useWindowLoaded from './useWindowLoaded';

const usePreloadImages = (sources: string[], suffix?: string) => {
  const [preloaded, setPreloaded] = useState(false);

  const windowLoaded = useWindowLoaded();

  const preloadImages = useCallback(() => {
    setPreloaded(false);

    for (const src of sources) {
      new Image().src = defaultLoader({ src, suffix });
    }

    setPreloaded(true);
  }, [sources, suffix]);

  useEffect(() => {
    if (windowLoaded) preloadImages();
  }, [windowLoaded, preloadImages]);

  return { preloaded };
};

export default usePreloadImages;
